module.exports = __webpack_public_path__ + "../resources/img/bg_pv1_01.e82e120f.png";